import { isAuthError, isForbiddenError } from '@/context/services/type';

function isForbiddenResult(result: unknown): boolean {
  if (result === null || typeof result !== 'object') return false;
  if (!('data' in result)) return false;
  const data = result.data;
  if (data === null || typeof data !== 'object') return false;
  if (!('status' in data) || typeof data.status !== 'number') return false;
  return !!(isAuthError(data.status) || isForbiddenError(data.status));
}

async function handleCheckPermission({
  fnCheckPermission,
  onCheckSuccess,
  onCheckFailure,
}: {
  fnCheckPermission?: () => void | Promise<unknown>;
  onCheckSuccess: () => void;
  onCheckFailure: () => void;
}): Promise<void> {
  try {
    if (!fnCheckPermission) return;
    const result = await fnCheckPermission();
    if (isForbiddenResult(result)) {
      onCheckFailure();
    } else {
      onCheckSuccess();
    }
  } catch {
    onCheckFailure();
  }
}

export const useCheckInvoiceReportsProtectedResources = () => {
  return { handleCheckPermission };
};
